import React from 'react';
import Svg, { Path, RadialGradient, Stop } from 'react-native-svg';

function CustomCarSVG({ color }) {
  return (
    <Svg
      x="0px"
      y="0px"
    >
      <Path
        id="rect959"
        fill="#60585A"
        d="M132.802,664.502h11.311c5.057,0,9.156,4.1,9.156,9.156v65.62c0,5.058-4.1,9.156-9.156,9.156
	h-11.311c-5.057,0-9.156-4.099-9.156-9.156v-65.62C123.646,668.602,127.745,664.502,132.802,664.502z"
      />
      <Path
        id="rect958"
        fill="#60585A"
        d="M447.437,653.836h11.311c5.057,0,9.156,4.1,9.156,9.156v65.621c0,5.057-4.1,9.156-9.156,9.156
	h-11.311c-5.058,0-9.156-4.1-9.156-9.156v-65.621C438.281,657.936,442.379,653.836,447.437,653.836z"
      />
      <Path
        id="rect317"
        fill="#60585A"
        d="M455.436,104.562h11.311c5.057,0,9.156,4.1,9.156,9.156v65.621c0,5.057-4.1,9.156-9.156,9.156
	h-11.311c-5.057,0-9.156-4.099-9.156-9.156v-65.621C446.28,108.662,450.379,104.562,455.436,104.562z"
      />
      <Path
        id="rect316"
        fill="#60585A"
        d="M124.639,107.849h11.311c5.058,0,9.156,4.1,9.156,9.156v65.621
	c0,5.057-4.099,9.156-9.156,9.156h-11.311c-5.057,0-9.156-4.099-9.156-9.156v-65.621
	C115.483,111.949,119.582,107.849,124.639,107.849z"
      />
      <RadialGradient id="path184_1_" cx="669.6125" cy="537.1904" r="548.8004" gradientTransform="matrix(0.7018 0 0 -1.197 -170.9626 1041.4243)" gradientUnits="userSpaceOnUse">
        <Stop offset="0" stopColor="#1F1F1F" />
        <Stop offset="1" stopColor="#000000" />
      </RadialGradient>
      <Path
        id="path184"
        fill={color}
        stroke="#000000"
        d="M296.899,835.086c-120.595,2.519-139.077-19.113-156.899-22.676
	c-17.817-41.357-21.2-390.069-10.511-418.578c7.991-64.569-5.265-75.261-9.266-153.082c-7.615-90.884,10.469-40.347-4.734-132.764
	c23.1-96.22-20.409-98.179,179.734-107.327C478.893,3.221,453.03,11.769,476.12,107.987c-15.203,92.418,2.881,41.881-4.734,132.764
	c-4.001,77.816-17.257,88.508-9.266,153.082c10.689,28.505,7.307,377.216-10.511,418.578
	c-27.894,16.161-101.812,22.676-154.724,22.676H296.899z"
      />
      <Path
        id="path230"
        fill={color}
        stroke="#000000"
        strokeOpacity="0.4591"
        d="M145.949,47.484
	c-12.443,19.909-11.536,209.278,8.373,224.209c19.23-15.839,130.631-30.552,151.813-29.185
	c21.638-1.591,106.328,8.591,132.348,24.208c7.015,2.272,21.04-219.229,1.13-234.161C377.389,15.124,170.83,15.124,145.949,47.477
	V47.484z"
      />
      <RadialGradient id="path272_1_" cx="917.0979" cy="694.1172" r="15.8491" gradientTransform="matrix(0.4169 0 0 -3.8752 -267.8295 3111.9834)" gradientUnits="userSpaceOnUse">
        <Stop offset="0" stopColor="#FFFFFF" />
        <Stop offset="1" stopColor="#696969" />
      </RadialGradient>
      <Path
        id="path272"
        fill="url(#path272_1_)"
        d="M150.576,300.639l22.967,87.928c0,0,0,164.867-3.28,167.608
	c-3.282,2.747-29.529,49.458-29.529,49.458s6.562-299.497,9.844-305L150.576,300.639z"
      />
      <RadialGradient id="path274_1_" cx="877.6614" cy="694.1172" r="15.8491" gradientTransform="matrix(-0.4169 0 0 -3.8752 848.3018 3106.6514)" gradientUnits="userSpaceOnUse">
        <Stop offset="0" stopColor="#FFFFFF" />
        <Stop offset="1" stopColor="#696969" />
      </RadialGradient>
      <Path
        id="path274"
        fill="url(#path274_1_)"
        d="M446.332,295.306l-22.967,87.928c0,0,0,164.868,3.28,167.608
	c3.282,2.748,29.528,49.458,29.528,49.458s-6.561-299.497-9.843-305L446.332,295.306z"
      />
      <RadialGradient id="path275_1_" cx="299.6829" cy="273.77" r="91.231" gradientTransform="matrix(1.6042 0 0 -0.7914 -183.7809 533.9191)" gradientUnits="userSpaceOnUse">
        <Stop offset="0" stopColor="#FFFFFF" />
        <Stop offset="1" stopColor="#696969" />
      </RadialGradient>
      <Path
        id="path275"
        fill="url(#path275_1_)"
        d="M150.818,274.519c0,0,69.892-28.687,147.866-29.42
	c70.214-0.684,101.925,10.263,144.635,26.684c-5.177,52-10.354,101.261-23.297,117.683c-119.069-30.108-126.833-30.108-245.902,0
	c-2.592-16.414-25.889-112.211-23.3-114.942L150.818,274.519z"
      />
      <Path
        id="path185"
        opacity="0.62"
        fillOpacity="0.7044"
        stroke="#000000"
        d="M154.814,277.516c0,0,68.027-26.41,143.931-27.085
	c68.342-0.629,99.206,9.449,140.783,24.566c-5.038,47.872-10.077,93.222-22.676,108.34
	c-115.901-27.715-123.452-27.714-239.354,0.001c-2.52-15.117-25.195-103.301-22.677-105.821L154.814,277.516z"
      />
      <RadialGradient id="path270_1_" cx="396.345" cy="32.5439" r="128.2708" gradientTransform="matrix(1.2471 0 0 -0.8235 -193.3944 702.9675)" gradientUnits="userSpaceOnUse">
        <Stop offset="0" stopColor="#FFFFFF" />
        <Stop offset="0.2095" stopColor="#DADADA" />
        <Stop offset="0.5821" stopColor="#9D9D9D" />
        <Stop offset="0.8562" stopColor="#777777" />
        <Stop offset="1" stopColor="#696969" />
      </RadialGradient>
      <Path
        id="path270"
        fill="url(#path270_1_)"
        d="M187.009,566.796c-13.192,63.318-23.744,184.683-23.744,184.683
	c21.106,18.469,129.276,26.384,131.921,26.384c7.915,0,116.083-7.915,134.556-34.298c0-15.83-10.554-129.276-21.107-179.404
	c-92.34,13.19-216.338,7.915-221.617,2.638L187.009,566.796z"
      />
      <Path
        id="path188"
        opacity="0.62"
        fillOpacity="0.7862"
        stroke="#000000"
        d="M192.607,572.299
	c-12.599,60.468-22.676,176.364-22.676,176.364c20.156,17.637,123.452,25.195,125.98,25.195c7.559,0,110.856-7.559,128.497-32.754
	c0-15.117-10.079-123.453-20.156-171.33c-88.184,12.597-206.601,7.559-211.646,2.52V572.299z"
      />
      <Path
        id="path189"
        fill="#333333"
        stroke="#000000"
        strokeOpacity="0.4591"
        d="M449.596,297.663l30.234,2.52
	c0,0,15.118,15.117,5.04,22.676c-10.079,7.559-35.274-2.519-35.274-2.519V297.663z"
      />
      <Path
        id="path190"
        fill="#333333"
        stroke="#000000"
        strokeOpacity="0.4591"
        d="M145.68,302.708l-30.235,2.519
	c0,0-15.117,15.118-5.039,22.676c10.079,7.559,35.274-2.52,35.274-2.52V302.708z"
      />
      <Path
        id="path304"
        fill="#F7FFD7"
        stroke="#000000"
        strokeWidth="1.082"
        strokeOpacity="0.2516"
        d="M162.356,18.158
	c-9.623,1.677-20.605,20.262-15.555,23.359c12.032-6.068,35.545-14.405,58.644-16.728c4.571-2.453,10.813-9.979,11.047-11.657
	C200.616,12.23,172.854,16.093,162.356,18.158L162.356,18.158z"
      />
      <Path
        id="path306"
        fill="#F7FFD7"
        stroke="#000000"
        strokeWidth="1.082"
        strokeOpacity="0.2516"
        d="M424.853,12.921
	c9.623,1.678,20.605,15.606,15.554,18.704c-12.03-6.067-35.544-8.004-58.643-10.328c-4.57-2.453-10.809-11.723-11.05-13.401
	C386.593,6.992,414.355,10.856,424.853,12.921L424.853,12.921z"
      />
      <Path
        id="path307"
        fill="none"
        stroke="#000000"
        strokeOpacity="0.3711"
        d="M226.037,11.071
	c39.566-6.983,106.48-6.401,134.993-2.911"
      />
      <Path
        id="path308"
        fill="none"
        stroke="#000000"
        strokeOpacity="0.3711"
        d="M226.037,13.98
	c39.566-6.983,106.48-6.401,134.993-2.911"
      />
      <Path
        id="path309"
        fill="none"
        stroke="#000000"
        strokeOpacity="0.3711"
        d="M226.037,17.471
	c39.566-6.983,106.48-6.401,134.993-2.911"
      />
      <Path
        id="path310"
        fill="none"
        stroke="#000000"
        strokeOpacity="0.3711"
        d="M226.037,21.544
	c39.566-6.4,104.734-5.238,132.668-3.493"
      />
      <Path
        id="path186"
        opacity="0.62"
        fillOpacity="0.6855"
        stroke="#000000"
        d="M152.294,315.304l17.637,80.625
	c0,0,0,151.172-2.52,153.69c-2.521,2.519-22.676,45.351-22.676,45.351s5.038-274.625,7.559-279.67V315.304z"
      />
      <Path
        id="path211"
        fill="none"
        stroke="#000000"
        d="M145.044,331.195c-2.488,27.375-15.989,472.96,4.977,472.843
	c74.504,28.229,236.367,25.153,297.054-7.466c18.697-0.076,7.465-445.476,4.977-472.843"
      />
      <Path
        id="path187"
        opacity="0.62"
        fillOpacity="0.7484"
        stroke="#000000"
        d="M444.562,310.27l-17.636,80.625
	c0,0,0,151.172,2.519,153.69c2.521,2.519,22.676,45.351,22.676,45.351s-5.038-274.625-7.559-279.67V310.27z"
      />
    </Svg>
  );
}

export default CustomCarSVG;
